import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QuestionnaireConfig } from 'app/@types/dto//questionnaire-config.model';
import { Observable } from 'rxjs';

import { UrlService } from './url.service';

@Injectable({
    providedIn: 'root',
})
export class QuestionnaireConfigHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    get(orgId: string, entityId: string): Observable<QuestionnaireConfig> {
        return this.http.get<QuestionnaireConfig>(this.urlService.getQuestionnaireConfig(orgId, entityId));
    }
}
